import type { API } from '@setplex/tria-api'
import { use as logic } from './logic'

export function use(api: API) {
  logic(api)
}
